var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInsights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.499,51.501a24.73228,24.73228,0,0,0,34.44483.50335L69.46973,70.53027l1.06054-1.06054L52.00439,50.94385A24.737,24.737,0,1,0,16.499,51.501Zm1.06055-33.94141a23.25028,23.25028,0,1,1,0,32.88086A23.178,23.178,0,0,1,17.55957,17.55957Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25,46a.7502.7502,0,0,0,.75.75h8a.7502.7502,0,0,0,.75-.75c0-3.582,4.15625-6.8916,4.26562-6.98438a12.75,12.75,0,1,0-17.96386.06006C25.09375,39.1084,29.25,42.40674,29.25,46ZM26.04492,22.04492A11.253,11.253,0,0,1,42.02246,37.895c-.18359.14355-4.252,3.376-4.72754,7.355H34.75V30.75H38v-1.5H30v1.5h3.25v14.5H30.70508c-.47559-3.979-4.54-7.20752-4.66016-7.29492A11.26243,11.26243,0,0,1,26.04492,22.04492Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 49.25,
    width: 8,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsights);
export default __webpack_public_path__ + "static/media/icon_insights.1ed67938152b3c3203af20e708688f32.svg";
export { ForwardRef as ReactComponent };